import { Image } from "@/components/Image/Image";

interface HotelImageListProps {
  images: { url: string; name: string }[];
  onImageClick: (index: number) => void;
}

export function HotelImageList({ onImageClick, images }: HotelImageListProps) {
  return (
    <div className="grid w-full grid-cols-2 gap-4">
      {images.map(({ url, name }, index) => (
        <button
          type="button"
          key={url}
          className="relative aspect-[17/13] overflow-hidden"
          onClick={() => {
            onImageClick(index + 1);
          }}
        >
          <Image
            src={url}
            alt={name}
            className="h-full w-full rounded-lg object-cover object-center"
          />
        </button>
      ))}
    </div>
  );
}
